/**
 * package: com.inq.stage
 * class: ViewportMgrImplPhone
 * @extends com.inq.stage.ViewportMgrImplMobile
 * @constructor
 */
com.inq.stage.ViewportMgrImplPhone = function() {
	com.inq.stage.ViewportMgrImplMobile.call(this);
};

/* specify hierary */
$hxClasses.extend(com.inq.stage.ViewportMgrImplMobile, com.inq.stage.ViewportMgrImplPhone, 'com.inq.stage.ViewportMgrImplPhone');


/**
 * fixPositioning
 *
 * $type TFun([],TEnum(Void,[]))
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplPhone
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhone.prototype.fixPositioning = function() {
	com.inq.stage.ViewportMgrImplMobile.prototype.fixPositioning.call(this);

    /**
     * on iphone, in order to do the nescessary scroll to the bottom, before the keyboard pops up,
     * if the the original page height is less than the size of the window,
     * it wont be possible to scroll to the bottom, so we increase the page height
     */
    if(this.clientDocument.documentElement.offsetHeight < window.top.innerHeight) {
		this.clientDocument.body.style.minHeight = window.top.innerHeight + "px";
    }

    /* We want to hide the location bar on phones
     * So we must increase the minimum height to gaurantee
     *   that we can scroll down one pixel to hide the location bar
     *   Native app doesn't have location bar and should not call this
     */
    if (this.clientWindow.pageYOffset == 0 && (!com.inq.utils.Capabilities.isAndroidWebView() && !com.inq.utils.Capabilities.isIOSWebView()))
	    this.clientWindow.scrollTo(this.clientWindow.pageXOffset, 1);
};


/** @type {com.inq.stage.ViewportMgrImplPhone} */
com.inq.stage.ViewportMgrImplPhone.prototype.__class__ = com.inq.stage.ViewportMgrImplPhone;
